<template>
  <div id="header" style="display: flex" :style="{background: bgTheme}">
    <img class="medium-icon pull-left padding-20" src="@/assets/back-light.png" v-if="showBackButton" v-on:click="back">
    <div class="header-wrapper text-light padding-10" style="width:100%">
      <div class="text-left text-large">{{getTranslatedText(headerTitle)}}</div>
      <div class="tickets align-hor center-ver">
        <div v-if="showWallet" :class="[showHistory ? 'margin-right-30' : '']" v-on:click="enableWalletClick ? redirectTo('wallet', '') : ''">
          <div class="container">
            <img class="large-icon" src="@/assets/ticket-white.svg">
            <div class="text-small centered text-grey">{{totalUserPointsEarned}}</div>
          </div>
          <p class="text-uppercase text-semi-small no-margin" v-if="walletType">{{getTranslatedText(walletType)}}</p>
          <div class="wrapper" v-else>
            <div class="comment animate green text-uppercase text-semi-small no-margin" :style="`--bgcolor: ${bgTheme}`"></div>
          </div>
        </div>
        <div v-if="showHistory" v-on:click="redirectTo('history', '')">
          <img class="reward-icon" src="@/assets/history.svg">
          <p class="text-uppercase text-semi-small no-margin">{{getTranslatedText('history')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { globals } from '@/mixins/globals'
  export default {
    name: 'custom-header',
    mixins: [globals],
    data() {
      return {
      }
    },
    methods: {
      redirectToHistory() {
        var path = "history"
        var params = {
          partner: self.partnerID, phone: self.userPhone
        };
        this.redirectTo(path, params);
      }
    }
  }
</script>

<style>
  #header {
    position: fixed;
    top: 0;
    display: block;
    left: 0;
    right: 0;
    z-index: 1;
    border-bottom: 1px solid #CCCCCC;
    height: 64px;
  }
  .header-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .header-block {
    flex: 1;
  }
  .full-height {
    height: 100%;
  }
  .title {
    font-size: 18px;
  }
  .rewards {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .reward-icon {
    width: 40px;
  }
  .cash,
  .token,
  .rewards {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .rewards-count {
    bottom: 10px;
    left: 10px;
    padding: 2px;
    min-height: 25px;
    height: auto;
    min-width: 25px;
    width: auto;
  }
  .count {
    font-size: 12px;
  }
</style>


// WEBPACK FOOTER //
// src/components/header.vue